@if ((submitStatus | async) === false) {
  <div class="custom-hubspot-form">
    <!-- Form Heading -->
    <div class="form-heading">
      <p>Get Mohawk Flooring design inspiration, decor trends & more!</p>
    </div>
    <form [formGroup]="form" (ngSubmit)="onSubmit()">
      <!-- First Name Field -->
      <div class="hs_firstname">
        <div class="input">
          <input
            type="text"
            class="hs-input"
            formControlName="firstName"
            placeholder="First Name"
            maxlength="100"
            autocomplete="given-name"
            />
        </div>
        @if (firstName.invalid && (firstName.touched || firstName.dirty)) {
          <ul class="hs-error-msgs">
            @if (firstName.errors?.required) {
              <li>First Name is required</li>
            }
            @if (firstName.errors?.maxlength) {
              <li>Maximum field limit reached</li>
            }
          </ul>
        }
      </div>
      <!-- Email Field -->
      <div class="hs_email">
        <div class="input">
          <input
            type="email"
            class="hs-input"
            formControlName="email"
            placeholder="Email Address"
            autocomplete="email"
            />
        </div>
        @if (email.invalid && (email.touched || email.dirty)) {
          <ul class="hs-error-msgs">
            @if (email.errors?.required) {
              <li>Email is required</li>
            }
            @if (email.errors?.pattern) {
              <li>Email is not in proper format</li>
            }
          </ul>
        }
      </div>
      <!-- Captcha Component -->
      <div class="hs_captcha_wrapper">
        <mflooring-captcha
          #captchaComponent
          formControlName="captcha"
          canvasId="hubspotCaptchaContent"
          strokeColor="#fff"
          fillColor="#fff"
          isDark="true"
          (captchaValid)="onCaptchaValid($event)"
        ></mflooring-captcha>
        @if (captcha.invalid && (captcha.touched || captcha.dirty)) {
          <ul class="hs-error-msgs">
            @if (captcha.errors?.required) {
              <li>Captcha is required</li>
            }
            @if (captcha.errors?.captchaInvalid && !isCaptchaValid) {
              <li>Please enter the correct captcha</li>
            }
          </ul>
        }
      </div>
      <!-- Submit Button -->
      <div class="hs_submit">
        <div class="actions">
          <button
            type="submit"
            class="hs-button"
            [disabled]="!form.valid || !isCaptchaValid || loading"
            >
            <span>Subscribe</span>
            @if (loading) {
              <mflooring-loading [presentation]="{ size: 'small', inButton: true }"></mflooring-loading>
            }
          </button>
        </div>
      </div>
    </form>
  </div>
}

<!-- Success Message -->
@if ((submitStatus | async) === true) {
  <div class="submitted-message">
    <p>Thanks for subscribing to Mohawk Inspiration Emails!</p>
  </div>
}
